import { Modal, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { WalletModalBody } from './WalletModalBody';
import React from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  disconnect: () => void;
};

export const WalletActionsModal = React.memo(({ isOpen, onClose, disconnect }: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent w={{ base: '250px', sm: '300px' }} p={'16px'} borderRadius={'24px'} backgroundColor={'greenA.900'}>
        <ModalCloseButton />
        <WalletModalBody disconnect={disconnect} />
      </ModalContent>
    </Modal>
  );
});
